export const ARTICLE_FILTER_STATUSES = {
    DRAFT: 1,
    PUBLISHED: 2
}